class C_FormationType
{
    constructor()
    {
        this.STANDART = 0;
        this.METEOR_SHOWER = 1;
        this.SKIRMISH = 2;
        this.RESCUE_MISSION = 3;
        this.COLLECTION = 4;
        this.SALVAGE_MISSION = 5;
        this.GG_MISSION = 6;


        this.TEXTS = ["METEOR SHOWER", "SKIRMISH", "RESCUE MISSION", "COLLECTION",
            "SALVAGE MISSION", "GG MISSION"];
    }
}

export default (new C_FormationType);